import React from "react";
import styled from "styled-components";
import { getEnvString } from "src/components/UserAccount/TermsAndPrivacy/TermsAndPrivacyLinks/TermsAndPrivacyLinks";
import { OnlineShopperState } from "store/types/state";

export const Link = styled("a")`
    color: ${(props) => props.theme.palette.grey[60]};
    text-decoration: underline;
`;

const FinServTermsLink = ({ env }: { env: OnlineShopperState["env"] }) => {
    const link = `https://${getEnvString(env)}onlineshopper.dealerinspire.com/legal/FinServ/terms`;

    return (
        <span>
            <Link href={link} target="_blank">
                {"FinServ Terms of Use"}
            </Link>
        </span>
    );
};

export default FinServTermsLink;
